<section class="our-team section">
  <div class="our-team__inner container">
    <div class="our-team__intro">
      <h2 class="our-team__title title-dark">Our Team</h2>
      <p class="our-team__description subheading-dark">
        We are a small team, who caught lightning in a bottle. A team of creatives and engineers,
        completely obsessed, who don't separate the week from the weekend because there is nothing
        on earth we'd rather be doing than building EVRN.
      </p>
    </div>

    @for (member of teamMembers; track member.name) {
      <article
        #teamCard
        class="our-team__card"
        [attr.aria-label]="member.name + ', ' + member.role"
      >
        <img class="our-team__portrait" loading="lazy" [src]="member.image" [alt]="member.name" />
        <div class="our-team__overlay" aria-hidden="true"></div>

        <div class="our-team__caption">
          <p class="our-team__name type-title-h9">{{ member.name }}</p>
          <p class="our-team__role type-title-h9">{{ member.role }}</p>
        </div>
      </article>
    }
  </div>
</section>
